import React, { useEffect, useState } from 'react';
import { StepContainer, NavigationButtons, InfoBox } from '../index';
import { useWizard } from '../../wizard';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const formatDate = (dateStr: string) => {
  const [y, m, d] = dateStr.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  const months = ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'];
  return `${d}. ${months[m - 1]} ${y}`;
};

const BookingSummaryStep: React.FC = () => {
  const { selfServiceData, goNext, goBack } = useWizard();
  const [body, setBody] = useState<string[] | null>(null);
  useEffect(() => {
    contentApi.getByKey(contentKeys.tidsbestilling.bk_summary).then(c => {
      if (c?.body && c.body.length > 0) {setBody(c.body);}
    });
  }, []);
  return (
    <StepContainer title="Oversigt over din booking">
      {body && <InfoBox type="info">{body.map((p,i) => <p key={i}>{p}</p>)}</InfoBox>}
      <ul className="summary-list">
        <li>
          <span className="label">Sted</span>
          <span className="value">{selfServiceData.locationName || ''}</span>
        </li>
        <li>
          <span className="label">Dato</span>
          <span className="value">{selfServiceData.date ? formatDate(selfServiceData.date) : ''}</span>
        </li>
        <li>
          <span className="label">Tid</span>
          <span className="value">{selfServiceData.time ? `kl. ${selfServiceData.time}` : ''}</span>
        </li>
      </ul>
      <NavigationButtons onBack={goBack} onNext={goNext} nextText="Bekræft" />
    </StepContainer>
  );
};

export default BookingSummaryStep;
